import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { StoreContext } from './Store';
import localData from '../data/exercices';
import {
  errorsInBounds,
  correctAnswersInARow,
  errorsInExercice,
  numberOfOptionsInActivity
} from '../utils/stats';
import {
  deleteActivityFromSequence,
} from '../utils/arrayOperations';
import * as ROUTES from '../constants/routes';
import * as ROLES from '../constants/roles';

const IA = ({ children, history }) => {
  const {
    user: { user },
    tracking: {
      answers: ans,
      path: pat,
      storePath,
      activityId: actId,
      storeActivityId,
      storeAnswers
    },
    content: {
      content: cont,
      setContent,
    },
    sequence: {
      sequence: seq,
      storeSequence,
    },
    action: {
      action: act,
      resetParams,
    },
  } = useContext(StoreContext);

  let { content } = cont;
  if (!content) content = [];
  let { sequence } = seq;
  if (!sequence) sequence = [];
  let { answers } = ans;
  if (!answers) answers = [];
  let { path } = pat;
  if (!path) path = 0;


  let { activityId } = actId;
  if (!activityId) activityId = 0;
  let { action } = act;

  const initIAContent = {
    subject: null,
    grade: null,
    module: null, 
    activity: null,
    exercice: null,
    content_id: null,
  };
  const [iaKeys, orient] = useState(initIAContent);
  const {
    subject,
    grade,
    module: mod,
    activity,
    exercice,
    content_id,
  } = iaKeys;

  // retrieve data from IA keys
  // to-be replaced by API call to content server
  useEffect(() => {
    if (
      subject !== null &&
      grade !== null &&
      mod !== null &&
      activity !== null &&
      exercice !== null &&
      content_id !== null
    ) {
      const cont = [...localData].filter(item => {
        return item.subject === subject &&
        item.grade === grade &&
        item.module === mod &&
        item.path === path &&
        item.activity === activity &&
        item.exercice === exercice &&
        item.content_id === content_id
      });
      if (
        cont &&
        cont.length > 0
      ) {
        setContent({ content: cont, token: user.token });
      }
    }
  }, [subject, grade, mod, path, activity, exercice, content_id]);

  // content counter logic
  const lastSeq = sequence.length > 0 && sequence[sequence.length-1];
  
  const initContentCounter = (lastSeq.activity !== activityId) ? 0 : sequence.length > 0 &&
    sequence[sequence.length-1].content_id || 0

  const [contentCounter, setContentCounter] = useState(initContentCounter);

  const nextContent = () => {
    setContentCounter(contentCounter+1);
  }

  useEffect(() => {
    if (!!user && user.roles.includes(ROLES.TEACHER_DEMO)) {
      console.log(resetParams);
      setContentCounter(0);
      setExoCounter(1);
      setContent({ content: []});
      storeSequence({ sequence: [], token: user.token });
      storeActivityId({ activityId: resetParams.activityId, user: user.token });
      storePath({ path: resetParams.path, user: user.token });
      storeAnswers({ answers: [], user: user.token});
    }
  }, [resetParams]);

  // inc content number
  useEffect(() => {
    if (
      content &&
      content.length > 0 &&
      content[0].type === "message"
    ) {
      let id = setInterval(() => {
        nextContent();
      }, 1000);
      return () => clearInterval(id);
    }
  }, [sequence]);

  // exercice counter logic
  const initExoCounter = (activityId === 0 ) ? 0 :
    (lastSeq.activity !== activityId) ? 1 : sequence.length > 0 &&
    sequence[sequence.length-1].exercice || 0

  const [exoCounter, setExoCounter] = useState(initExoCounter);

  const nextExercice = () => {
    setContentCounter(0);
    if (
      answers.length > 0
    ) {
      setExoCounter(answers[answers.length-1].exercice+1)
    };
  }

  // inc exercice number
  useEffect(() => {
    if (
      answers.length > 0 &&
      sequence.length > 0 &&
      answers[answers.length-1].exercice ===
      sequence[sequence.length-1].exercice &&
      sequence[sequence.length-1].content !== "Oups 🤦‍. Essayez encore !" &&
      answers[answers.length-1].exercice < 10 &&
      sequence[sequence.length-1].content !== "On s'entraîne 🚀"
    ) {
      nextExercice();
    }
  }, [answers]);

  const nextActivity = (act) => {
    setContentCounter(0);
    setExoCounter(1);
    storeActivityId({ activityId: act, token: user.token });
  }

  const sameActivity = () => {
    setContentCounter(0);
    setExoCounter(1);
    const newSeq = deleteActivityFromSequence(sequence, activityId);
    storeSequence({ sequence: [...newSeq], token: user.token });
  }

  // conversation mechanics
  useEffect(() => {
    if (
      sequence.length === 0 ||
      sequence.length > 0 &&
      sequence[sequence.length-1].type === "message" &&
      action === "go"
    ) {
      orient({
        subject: "french",
        grade: 11,
        module: 1,
        path: path,
        activity: activityId,
        exercice: exoCounter,
        content_id: contentCounter, 
      });
    }
    if (
      sequence.length > 0 &&
      (
        sequence[sequence.length-1].type === "answer" ||
        sequence[sequence.length-1].type === "feedback"
      )
    ) {
      let id = setTimeout(() => {
        orient({
          subject: "french",
          grade: 11,
          module: 1,
          path: path,
          activity: activityId,
          exercice: exoCounter,
          content_id: contentCounter, 
        });
      }, 2000);
      return () => clearTimeout(id);
    }
  }, [contentCounter, exoCounter, activityId, sequence, action]);

  // reset counters once activity is finished
  const resetCounters = () => {
    setContentCounter(0);
    setExoCounter(1);
  };

  // launchTest conditions
  useEffect(() => {
    if (
      answers.length > 0 &&
      activityId === 0
    ) {
      if (
        answers[answers.length-1].content === "On s'entraîne 🚀"
      ) {
        resetCounters();
        storeActivityId({ activityId: 1, token: user.token });
        if (!!user && user.roles.includes(ROLES.TEACHER_DEMO)) {
          history.push(ROUTES.GALLERY);
        } else {
          history.push(ROUTES.CHATBOT);
        }
      }
      // if no error until q3 go to question 7, path 2 or 3
      if (
        errorsInBounds(answers, activityId, 1, 7) === 0 &&
        answers[answers.length-1].exercice === 3
      ) {
        setExoCounter(7);
      }
      // if errors in q4, q6 => path 1
      if (
        sequence.length > 0 &&
        errorsInBounds(answers, activityId, 4, 7) > 0 &&
        answers[answers.length-1].exercice >= 4 &&
        sequence[sequence.length-1].content !== "On s'entraîne 🚀"
      ) {
        let id = setTimeout(() => {
          setContent({ content: [{
            subject: "french",
            grade: 11,
            module: 1,
            path: path,
            activity: activityId,
            exercice: exoCounter,
            content_id: contentCounter,
            type: "feedback",
            format: "text",
            content: "Résultat du test : je décèle une difficulté à découper une suite de mots en groupes organisés. On s'entraîne ?",
            correct_answer: null
          }], token: user.token })
        }, 1500);
        id = setTimeout(() => {
          setContent({ content: [{
            subject: "french",
            grade: 11,
            module: 1,
            path: path,
            activity: activityId,
            exercice: exoCounter,
            content_id: contentCounter,
            type: "button",
            format: "text",
            content: "On s'entraîne 🚀",
            correct_answer: null
          }], token: user.token })
        }, 2000);
        resetCounters();
        storePath({ path: 1, token: user.token });
        return () => clearTimeout(id);
      }
      // if no errors at all between q4 and q9 => path 3
      if (
        sequence.length > 0 &&
        errorsInBounds(answers, activityId, 4, 10) === 0 &&
        answers[answers.length-1].exercice === 9 &&
        sequence[sequence.length-1].content !== "On s'entraîne 🚀"
      ) {
        let id = setTimeout(() => {
          setContent({ content: [{
            subject: "french",
            grade: 11,
            module: 1,
            path: path,
            activity: activityId,
            exercice: exoCounter,
            content_id: contentCounter,
            type: "feedback",
            format: "text",
            content: "Résultat du test : vous maîtrisez bien les structures de phrase. On va corser la difficulté en travaillant les ambiguïtés syntaxiques.",
            correct_answer: null
          }], token: user.token })
        }, 1000);
        id = setTimeout(() => {
          setContent({ content: [{
            subject: "french",
            grade: 11,
            module: 1,
            path: path,
            activity: activityId,
            exercice: exoCounter,
            content_id: contentCounter,
            type: "button",
            format: "text",
            content: "On s'entraîne 🚀",
            correct_answer: null
          }], token: user.token })
        }, 2000);
        resetCounters();
        storePath({ path: 3, token: user.token });
      }
      // if errors in q7 q9 only, path2
      if (
        sequence.length > 0 &&
        errorsInBounds(answers, activityId, 7, 10) > 0 &&
        answers[answers.length-1].exercice >= 7 &&
        sequence[sequence.length-1].content !== "On s'entraîne 🚀"
      ) {
        let id = setTimeout(() => {
          setContent({ content: [{
            subject: "french",
            grade: 11,
            module: 1,
            path: path,
            activity: activityId,
            exercice: exoCounter,
            content_id: contentCounter,
            type: "feedback",
            format: "text",
            content: "Résultat du test : je décèle une difficulté à identifier les dépendances entre les groupes, à l'intérieur d'une phrase. On s'entraîne ?",
            correct_answer: null
          }], token: user.token })
        }, 1000);
        id = setTimeout(() => {
          setContent({ content: [{
            subject: "french",
            grade: 11,
            module: 1,
            path: path,
            activity: activityId,
            exercice: exoCounter,
            content_id: contentCounter,
            type: "button",
            format: "text",
            content: "On s'entraîne 🚀",
            correct_answer: null
          }], token: user.token })
        }, 2000);
        resetCounters();
        storePath({ path: 2, token: user.token });
      }
    }
  }, [contentCounter, exoCounter, answers]);

  useEffect(() => {
    if (
      activityId > 0
    ) {
      if ( 
        answers.length > 0 &&
        answers[answers.length-1].content === "Au suivant !"
      ) {
        resetCounters();
      }
      if ( 
        answers.length > 0 &&
        answers[answers.length-1].content === "Recommencer"
      ) {
        sameActivity();
      }
    }
  }, [answers])

  // activity conditions (# > 0)
  useEffect(() => {
    if (
      activityId > 0
    ) {
      if (
        answers.length > 0 &&
        sequence.length > 0 &&
        answers[answers.length-1].exercice === 10 &&
        sequence[sequence.length-1].type === "feedback" && // last action from bot: feedback
        sequence[sequence.length-1].content !== "Oups 🤦‍. Essayez encore !" &&
        answers[answers.length-1].content !== "Recommencer" &&
        answers[answers.length-1].content !== "Au suivant !" &&
        sequence[sequence.length-1].type !== "choice" &&
        !!user &&
        user.roles.includes(ROLES.STUDENT_DEMO)
      ) {
        let id1 = setTimeout(() => {
          setContent({ content: [{
            subject: "french",
            grade: 11,
            module: 1,
            path: path,
            activity: activityId,
            exercice: exoCounter,
            content_id: contentCounter,
            type: "feedback",
            format: "text",
            content: "Entraînement terminé ! On passe au suivant ?",
            correct_answer: null
          }], token: user.token })
        }, 2000);
        let id2 = setTimeout(() => {
          setContent({ content: [{
            subject: "french",
            grade: 11,
            module: 1,
            path: path,
            activity: activityId,
            exercice: exoCounter,
            content_id: contentCounter,
            type: "choice",
            format: "text",
            content: ["Recommencer", "Au suivant !"],
            correct_answer: null
          }], token: user.token })
        }, 2000);
        return () => {
          clearTimeout(id1);
          clearTimeout(id2);
        };
      }
    }
  }, [sequence]);

  useEffect(() => {
    if (
      answers.length > 0 &&
      activityId > 0 &&
      sequence.length > 0 &&
      correctAnswersInARow(
        answers,
        activityId,
        3
      ) &&
      answers[answers.length-1].exercice < 10 &&
      sequence[sequence.length-1].content !== "Je pense que vous avez compris. On change d'entraînement ?" &&
      sequence[sequence.length-1].type !== "choice" &&
      sequence[sequence.length-1].content !== "On s'entraîne 🚀" &&
      !!user &&
      user.roles.includes(ROLES.STUDENT_DEMO)
    ) {
      let id1 = setTimeout(() => {
        setContent({ content: [{
          subject: "french",
          grade: 11,
          module: 1,
          path: path,
          activity: activityId,
          exercice: exoCounter,
          content_id: contentCounter,
          type: "feedback",
          format: "text",
          content: "Je pense que vous avez compris. On change d'entraînement ?",
          correct_answer: null
        }], token: user.token })
      }, 2000);
      let id2 = setTimeout(() => {
        setContent({ content: [{
          subject: "french",
          grade: 11,
          module: 1,
          path: path,
          activity: activityId,
          exercice: exoCounter,
          content_id: contentCounter,
          type: "choice",
          format: "text",
          content: ["Continuer", "Au suivant !"],
          correct_answer: null
        }], token: user.token })
      }, 3000);
      return () => {
        clearTimeout(id1);
        clearTimeout(id2);
      };
    }
  }, [answers]);

  // exercice conditions
  // when no error in answer
  useEffect(() => {
    if (
      answers.length > 0 &&
      answers[answers.length-1].activity > 0 &&
      answers[answers.length-1].isCorrect &&
      sequence.length > 0 &&
      sequence[sequence.length-1].type === "answer"
    ) {
      let id = setTimeout(() => {
        setContent({ content: [{
          subject: "french",
          grade: 11,
          module: 1,
          path: path,
          activity: activityId,
          exercice: exoCounter,
          content_id: contentCounter,
          type: "feedback",
          format: "text",
          content: "Bien joué 👍",
          correct_answer: null
        }], token: user.token })
      }, 1000);
      return () => clearTimeout(id);
    }
  }, [answers]);

  // when error in answer and less than 2 options (activity 1)
  useEffect(() => {
    if (
      answers.length > 0 &&
      answers[answers.length-1].activity > 0 &&
      answers[answers.length-1].isCorrect === false &&
      path > 0 &&
      sequence.length > 0 &&
      numberOfOptionsInActivity(localData, activityId, path) === 2 &&
      sequence[sequence.length-1].type !== "qcm" &&
      sequence[sequence.length-1].type !== "choice"
    ) {
      const answerL1 = answers[answers.length-1];
      const contentL1 = localData.filter(item =>
        item.subject === answerL1.subject &&
        item.grade === answerL1.grade &&
        item.module === answerL1.module &&
        item.path === answerL1.path &&
        item.activity === answerL1.activity &&
        item.exercice === answerL1.exercice &&
        item.content_id === answerL1.content_id
      )[0];
      const cleanContentL1 = Array.from(contentL1.content
        .substr(1, contentL1.content.length-2)
        .split("||"));

      if (cleanContentL1.length === 2) {
        const rawCorrectAnswer = contentL1.correct_answer;
        const cleanCorrectAnswer = (rawCorrectAnswer.length > 1) ?
          Array.from(rawCorrectAnswer
            .substr(1, rawCorrectAnswer.length-2)
            .split("||")).map(str => cleanContentL1[parseInt(str)-1]).join('" ou "') :
            cleanContentL1[parseInt(rawCorrectAnswer)-1];
        let id = setTimeout(() => {
          setContent({ content: [{
            subject: "french",
            grade: 11,
            module: 1,
            path: path,
            activity: activityId,
            exercice: exoCounter,
            content_id: contentCounter,
            type: "feedback",
            format: "text",
            content: `Oups 🤦‍. La bonne réponse est : "${cleanCorrectAnswer}".`,
            correct_answer: null
          }], token: user.token })
        }, 1000);
        return () => clearTimeout(id);
      }
    }
  }, [answers]);

  // when error in answer and more than 2 options (activity 2)
  useEffect(() => {
    if (
      answers.length > 0 &&
      answers[answers.length-1].activity > 0 &&
      answers[answers.length-1].isCorrect === false &&
      path > 0 &&
      sequence.length > 0 &&
      numberOfOptionsInActivity(localData, activityId, path) > 2 &&
      sequence[sequence.length-1].type !== "qcm"
    ) {
      const answerL1 = answers[answers.length-1];
      const contentL1 = localData.filter(item =>
        item.subject === answerL1.subject &&
        item.grade === answerL1.grade &&
        item.module === answerL1.module &&
        item.path === answerL1.path &&
        item.activity === answerL1.activity &&
        item.exercice === answerL1.exercice &&
        item.content_id === answerL1.content_id
      )[0];
      const cleanContentL1 = Array.from(contentL1.content
        .substr(1, contentL1.content.length-2)
        .split("||"));
        
      if (
        cleanContentL1.length > 2 &&
        errorsInExercice(answers) < 2
      ) {
        let id = setTimeout(() => {
          setContent({ content: [{
            subject: "french",
            grade: 11,
            module: 1,
            path: path,
            activity: activityId,
            exercice: exoCounter,
            content_id: contentCounter,
            type: "feedback",
            format: "text",
            content: "Oups 🤦‍. Essayez encore !",
            correct_answer: null
          }], token: user.token })
        }, 1000);
        id = setTimeout(() => {
          setContent({ content: [{
            subject: "french",
            grade: 11,
            module: 1,
            path: path,
            activity: activityId,
            exercice: exoCounter,
            content_id: contentCounter,
            type: "qcm",
            format: "text",
            content: `[${cleanContentL1.join('||')}]`,
            correct_answer: contentL1.correct_answer,
          }], token: user.token })
        }, 2000);
        return () => clearTimeout(id);
      } else if (
        errorsInExercice(answers) >= 2
      ) {
        const answerL2 = answers[answers.length-2];
        const contentL2 = localData.filter(item =>
          item.subject === answerL2.subject &&
          item.grade === answerL2.grade &&
          item.module === answerL2.module &&
          item.path === answerL2.path &&
          item.activity === answerL2.activity &&
          item.exercice === answerL2.exercice &&
          item.content_id === answerL2.content_id
        )[0];
        const cleanContentL2 = Array.from(contentL2.content
          .substr(1, contentL2.content.length-2)
          .split("||"));

        const rawCorrectAnswer = contentL2.correct_answer;
        const cleanCorrectAnswer = (rawCorrectAnswer.length > 1) ?
          Array.from(rawCorrectAnswer
            .substr(1, rawCorrectAnswer.length-2)
            .split("||")).map(str => cleanContentL2[parseInt(str)-1]).join('" ou "') :
            cleanContentL2[parseInt(rawCorrectAnswer)-1];
        let id = setTimeout(() => {
          setContent({ content: [{
            subject: "french",
            grade: 11,
            module: 1,
            path: path,
            activity: activityId,
            exercice: exoCounter,
            content_id: contentCounter,
            type: "feedback",
            format: "text",
            content: `Oups 🤦‍. La bonne réponse est : "${cleanCorrectAnswer}".`,
            correct_answer: null
          }], token: user.token })
        }, 1000);
        return () => clearTimeout(id);
      }
    }
  }, [answers]);

  return (
    <div>
      { children }
    </div>
  )
};

export default withRouter(IA);